<template>
    <div class="settings">
        <v-form v-model="valid">
            <v-row class="mt-6">
                <div class="mx-2 width-330">
                    <Select
                        itemText="name"
                        itemValue="id"
                        :selectionMaxLength="25"
                        v-model="studioId"
                        :items="salons"
                        label="Салон"
                        placeholder="Выбрать Салон"
                        :rules="[v => !!v || 'Параметр обязателен']"
                        filled
                    ></Select>
                </div>
            </v-row>
            <v-row justify="end">
                <v-btn @click="save" color="mainNew" class="mr-3 mt-2 white--text" :disabled="disableSaveBtn"
                    >Сохранить</v-btn
                >
                <v-btn v-if="isChange" @click="cancel" outlined class="mr-3 mt-2 cancel-btn">Отмена</v-btn>
                <v-btn v-if="!isChange" @click="cancel" outlined class="mr-3 mt-2 cancel-btn"
                    >Не добавлять источник</v-btn
                >
            </v-row>
        </v-form>
    </div>
</template>

<script>
import { objectEquals } from '@/utils.js'
import { mapState } from 'vuex'
import Select from '@/components/inputs/Select'
import cfg from '../../../../config'
import { getSalons } from '@root/src/api/connectors/lenaLenina'
export default {
    props: {
        isChange: {
            type: Boolean,
            default: false,
        },
        connector: {
            type: Object,
            default: null,
        },
    },
    components: { Select },
    data: () => ({
        valid: false,
        studioId: [],
        salons: [],
        settings: null,
        cfg,
    }),
    computed: {
        ...mapState('project', ['loggedAddingConnector']),
        settingsChanged() {
            return !objectEquals(this.settings, this.prevSettings)
        },
        disableSaveBtn() {
            if (this.isChange && !this.settingsChanged) {
                return true
            } else {
                return !this.valid
            }
        },
    },
    watch: {
        studioId() {
            this.settings = this.getSettings()
        },
    },
    methods: {
        getSettings() {
            return {
                studioId: this.studioId,
            }
        },
        cancel() {
            this.$parent.$emit('cancel')
        },
        async save() {
            if (!this.isChange) {
                const settings = this.getSettings()
                this.$parent.$emit('createConnector', { settings })
            } else {
                this.$parent.$emit('changeSettings', {
                    prevSettings: this.prevSettings,
                    settings: this.getSettings(),
                    additionalData: [],
                })
            }
        },
    },
    async created() {
        if (!this.isChange) {
            const projectId = this.loggedAddingConnector.projectId
            this.$store.commit('startLoading')
            const { error, data } = await getSalons(projectId)
            if (error) {
                this.$store.dispatch('callNotify', 'Ошибка при загрузке данных')
            } else {
                this.salons = data
            }
            this.$store.commit('endLoading')
        } else {
            this.$store.commit('startLoading')
            const { error, data } = await getSalons(this.connector.projectId)
            if (error) {
                this.$store.dispatch('callNotify', 'Ошибка при загрузке данных')
            } else {
                this.salons = data
            }
            this.$store.commit('endLoading')
            this.studioId = this.connector.studioId
            this.prevSettings = this.getSettings()
            this.settings = this.getSettings()
        }
    },
}
</script>
<style lang="sass" scoped>
.cancel-btn
    border-color: #0000001F !important
.width-330
    width: 330px !important
</style>
